import axios from 'axios';
import qs from 'query-string';
import { apiConfig } from '../api-config';

export interface GetNotificationParams {
  userId: number;
  tokenKey: string;
  typeUser: string;
}

export const getNotificationRead = (params: GetNotificationParams) => {
  const query = qs.stringify(params);

  const getRead = apiConfig.get(`/api/Notification/get-read?${query}`);

  return axios
    .all([getRead])
    .then(
      axios.spread((resp1) => [
        ...(resp1.data.objectResult || []),
      ]),
    )
    .catch((err) => ({ hasErrors: true, err }));
};

export const getNotificationUnread = (params: GetNotificationParams) => {
  const query = qs.stringify(params);

  const getUnread = apiConfig.get(`/api/Notification/get-unread?${query}`);

  return axios
    .all([getUnread])
    .then(
      axios.spread((resp1) => [
        ...(resp1.data.objectResult || []),
      ]),
    )
    .catch((err) => ({ hasErrors: true, err }));
};
